import React from "react";

export default function PromoItem({promo}) {
	const OptionalLinkWrapper = ({ children }) => {
		return promo.href ? (
			<a className="pano_promo" href={promo.href} target="_blank" rel="noopener noreferrer">
				{children}
			</a>
		) : (
			<div className="pano_promo">{children}</div>
		);
	};

	return (
		<OptionalLinkWrapper>
			<img src={promo.img} alt={promo.alt} />
		</OptionalLinkWrapper>
	)
}



// WEBPACK FOOTER //
// ./src/components/home/PromoItem.js